export const podAdvantages = [
    {
        title: 'Pedidos online',
        desc: 'Pode montar o pacote de benefícios da sua equipe através do Portal do RH.'
    },
    {
        title: 'Segurança jurídica',
        desc: 'Os saldos dos benefícios ficam separados e possuem rede de aceitação específica para garantir a finalidade de uso de cada um.'
    },
    {
        title: 'Entrega onde você precisar',
        desc: 'Pode cadastrar o endereço dos seus colaboradores que a gente entrega em mãos.'
    },
    {
        title: 'Aceito em milhões de estabelecimentos',
        desc: 'Pode contar com o Pod para as despesas do time. Ótimo para quem tem equipes espalhadas pelo Brasil, em home office ou não.'
    },
    {
        title: 'Atendimento dedicado',
        desc: 'Conte com o nosso time de suporte a empresas.'
    },
    {
        title: 'Líder de mercado em benefícios PAT',
        desc: 'Pode confiar. São 20 anos de mercado e 10 milhões de clientes atendidos diariamente.'
    }
]
